import { render, staticRenderFns } from "./labelled_editable_value.vue?vue&type=template&id=a44c157a&scoped=true&lang=pug"
import script from "./labelled_editable_value.vue?vue&type=script&lang=js"
export * from "./labelled_editable_value.vue?vue&type=script&lang=js"
import style0 from "./labelled_editable_value.vue?vue&type=style&index=0&id=a44c157a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44c157a",
  null
  
)

export default component.exports